import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { MDExServicemanBodyModel } from 'src/app/model/MDExServicemanBodyModel';
import { RegistrationModerationDocumentModel } from 'src/app/model/RegistrationModerationDocumentModel';

@Component({
  selector: 'app-secure-md-ex-serviceman',
  templateUrl: './md-ex-serviceman.component.html',
  styleUrls: []
})
export class MDExServicemanComponent implements OnInit {
  @Input() registrationModerationDocument: RegistrationModerationDocumentModel;
  verifyForm: FormGroup = new FormGroup({});
  isVerifyDisabled: boolean;
  verifyErrorMessage: string;
  @Output() onSubmit = new EventEmitter<MDExServicemanBodyModel>();

  constructor() { }

  ngOnInit(): void { 
    console.log(this.registrationModerationDocument);
    this.verifyForm = new FormGroup({
      nameAsOnCertificate: new FormControl(null, [Validators.required]),
      serviceName: new FormControl(null, [Validators.required]),
      applicantType: new FormControl(null, [Validators.required]),
      relationshipWithEX: new FormControl(null, [Validators.required]),
      isStampReadable: new FormControl(null, [Validators.required]),
      isStampFromZSWB: new FormControl(null, [Validators.required]),
      isSignaturePresent: new FormControl(null, [Validators.required]),
      isDateOfIssuePresent: new FormControl(null, [Validators.required]),
      // isQRCodePresent: new FormControl(null, [Validators.required]),
    });
  }

  onSubmitVerify() {
    console.log('verify submit clicked', this.verifyForm);
    this.verifyErrorMessage = null;
    if (this.verifyForm.valid) {
      this.onSubmit.emit(new MDExServicemanBodyModel(
        this.verifyForm.value.nameAsOnCertificate,
        this.verifyForm.value.serviceName,
        this.verifyForm.value.applicantType,
        this.verifyForm.value.relationshipWithEX,
        this.verifyForm.value.isStampReadable,
        this.verifyForm.value.isStampFromZSWB,
        this.verifyForm.value.isSignaturePresent,
        this.verifyForm.value.isDateOfIssuePresent,
        // this.verifyForm.value.isQRCodePresent
        ));
    }
    else {
      this.verifyErrorMessage = "Please enter all mandatory fields";
      this.isVerifyDisabled = false;
    }
  }
}
